import React from 'react';
import '../styles/TrustedBySection.css';
import AWSLogo from '../assets/partners/AWS.png';
import GoogleLogo from '../assets/partners/Google.png';
import MicrosoftLogo from '../assets/partners/Microsoft.png';
import HashiCorpLogo from '../assets/partners/HashiCorp.png';
import DatadogLogo from '../assets/partners/Datadog.jpg';
import GitLabLogo from '../assets/partners/GitLab.png';
import SnowflakeLogo from '../assets/partners/Snowflake.png';
import ElasticLogo from '../assets/partners/Elastic.png';
import OpenAILogo from '../assets/partners/OpenAI.png';

const partners = [
    { name: 'AWS', description: 'Amazon Web Services – Cloud infrastructure partner', initials: 'AWS', accent: '#1DB954', logo: AWSLogo },
    { name: 'Google Cloud', description: 'Partnered for AI/ML, BigQuery, and Kubernetes', initials: 'GC', accent: '#A259FF', logo: GoogleLogo },
    { name: 'Microsoft Azure', description: 'Enterprise cloud integration & compliance', initials: 'AZ', accent: '#1DB954', logo: MicrosoftLogo },
    { name: 'HashiCorp', description: 'Infrastructure automation with Terraform & Vault', initials: 'HC', accent: '#A259FF', logo: HashiCorpLogo },
    { name: 'Datadog', description: 'Observability & monitoring platform', initials: 'DD', accent: '#1DB954', logo: DatadogLogo },
    { name: 'GitLab', description: 'CI/CD pipelines & DevSecOps implementation', initials: 'GL', accent: '#A259FF', logo: GitLabLogo },
    { name: 'Snowflake', description: 'Data warehousing & analytics solutions', initials: 'SF', accent: '#1DB954', logo: SnowflakeLogo },
    { name: 'Elastic', description: 'Real-time search, logging, and analytics', initials: 'ES', accent: '#A259FF', logo: ElasticLogo },
    { name: 'OpenAI', description: 'AI/ML integrations and infrastructure management', initials: 'OA', accent: '#1DB954', logo: OpenAILogo },
  ];


const TrustedBySection: React.FC = () => {
    const duplicatedPartners = [...partners, ...partners]; // must be doubled for seamless scroll

    return (
        <section className="trustedby-section">
            <div className="home-section-header-h">
                <h2 className="home-section-title-h">Trusted By</h2>
                <p className="section-subtitle">Our partners and technology collaborators</p>
            </div>
            <div className="trustedby-grid-wrapper">
                <div className="trustedby-grid">
                    <div className="trustedby-inner">
                        {duplicatedPartners.map((partner, index) => (
                            <div className="trustedby-card" key={`${partner.name}-${index}`}>
                                <div className="trustedby-logo" style={!partner.logo ? { background: partner.accent } : undefined}>
                                    {partner.logo ? (
                                        <img src={partner.logo} alt={partner.name} className="trustedby-image" />
                                    ) : (
                                        <span className="trustedby-initials">{partner.initials}</span>
                                    )}
                                </div>
                                <div className="trustedby-info">
                                    <div className="trustedby-name">{partner.name}</div>
                                    <div className="trustedby-desc">{partner.description}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrustedBySection;
